import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=0612fa52"
import script from "./CustomerSummary.vue?vue&type=script&lang=js"
export * from "./CustomerSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports